import api from "./cofocusAPI";

export async function unfreezeAccount(UID) {
  if (!UID) return { success: false, error: "Required data not provided for request." };
  return api.getResponseData({
    url: `api/suspensions/unfreeze/${UID}`,
    method: "post",
    data: { UID },
    withCredentials: true,
  });
}

export default {
  unfreezeAccount,
};
